import { useT } from "@/i18n";
import { useSiteText, useSiteContent } from "@/context/SiteContentContext";

export default function About() {
    const { t, lang } = useT();
    const { content } = useSiteContent();
    const st = useSiteText(lang, t);
    const body = content[`about_body_${lang}`] || content.about_body_en || "";

    return (
        <div data-testid="about-page">
            <section className="px-4 md:px-8 py-6 md:py-8">
                <div className="grid grid-cols-12 gap-6">
                    <div className="col-span-12 md:col-span-2 font-mono text-xs uppercase tracking-[0.3em] text-[#5D3FD3]">
                        {st("about_kicker")}
                    </div>
                    <div className="col-span-12 md:col-span-10">
                        <h1 className="font-heading font-black text-4xl sm:text-5xl md:text-7xl lg:text-8xl uppercase tracking-tighter leading-[0.9]">
                            {st("about_title")}<span className="text-[#5D3FD3]">.</span>
                        </h1>
                    </div>
                </div>
            </section>

            <section className="px-4 md:px-8 py-6 md:py-8 grid grid-cols-12 gap-6">
                <div className="col-span-12 md:col-span-8">
                    <p className="font-body text-lg md:text-2xl text-black leading-relaxed">
                        {st("about_intro")}
                    </p>
                    {body && (
                        <div className="mt-8 font-body text-base md:text-lg text-[#333] leading-relaxed whitespace-pre-line max-w-3xl">
                            {body}
                        </div>
                    )}
                </div>
            </section>
        </div>
    );
}
